export enum SalesforceCallService {
  EVOX = 'EVOX',
  ZOOM = 'ZOOM'
}

export const isTaiwanCountry = (country?: string | null): boolean => {
  if (!country) return false;
  const normalized = country.trim().toLowerCase();
  return normalized === 'taiwan' || normalized === 'tw';
};

/** Taiwan users dial via Evox; all other countries use Zoom Phone. */
export const getSalesforceCallService = (
  country?: string | null
): SalesforceCallService =>
  isTaiwanCountry(country)
    ? SalesforceCallService.EVOX
    : SalesforceCallService.ZOOM;
